import { Buffer } from 'buffer';
import process from 'process/browser';

export function polyfill() {
	window.buffer = Buffer;
	window.Buffer = Buffer;
	window.process = process;
}

export default { polyfill };